export default __webpack_public_path__ + "static/media/Embudo.a9c3deaf.jpeg";